import { TFunction } from 'i18next';

import { bpErrorsCodes } from 'activate-errors';
import { Invoice } from 'lane-shared/domains/billingPayments/types';

import { LONG_TOAST_DURATION } from '../constants';
import { MarkAsBilledError } from './mapMarkAsBilledError';
import { MarkAsBilledResult } from './useMarkInvoiceAsBilled';

export async function confirmAndMarkAsBilled({
  invoice,
  markAsBilled,
  t,
}: {
  invoice: Invoice;
  markAsBilled: (invoice: Invoice) => Promise<MarkAsBilledResult>;
  t: TFunction;
}) {
  try {
    await window.Alert.confirm({
      title: t('abp.invoice.markAsBilledTitle'),
      message: t('abp.invoice.markAsBilledMessage'),
      confirmText: t('abp.actions.markAsBilled'),
    });
  } catch {
    return;
  }

  const result = await markAsBilled(invoice);

  if (result.status === 'billed') {
    await window.Toast.show(
      t('abp.invoice.markAsBilledSuccessToast'),
      LONG_TOAST_DURATION
    );

    return;
  }

  await window.Toast.show(
    getMarkAsBilledErrorMessage(result.error, t),
    LONG_TOAST_DURATION
  );
}

function getMarkAsBilledErrorMessage(error: MarkAsBilledError, t: TFunction) {
  switch (error.kind) {
    case 'NOT_ISSUED':
      return t(bpErrorsCodes.invoiceNotIssued.message);
    case 'ALREADY_BILLED':
      return t(bpErrorsCodes.invoiceAlreadyBilled.message);
    default:
      return error.message;
  }
}
